import { createContext, useContext, useLayoutEffect } from 'react';

export const CheckoutLayoutContext = createContext({
  setHeaderHidden: () => {}
});

/**
 * Hides the checkout header while the page is loading, so the loading
 * covers the whole screen instead of only the content below the header.
 */
export const useHideCheckoutHeader = (hidden) => {
  const { setHeaderHidden } = useContext(CheckoutLayoutContext);

  useLayoutEffect(() => {
    setHeaderHidden(hidden);

    return () => setHeaderHidden(false);
  }, [hidden]);
};
